/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const celo_chain_about = () => `Celo stands as a blockchain ecosystem with a mission to foster cryptocurrency adoption among smartphone users globally. Utilizing phone numbers as public keys, Celo aims to onboard billions of smartphone owners, including those lacking traditional banking access, into cryptocurrency transactions. The platform is engineered to offer a comprehensive range of stablecoins, decentralized identification solutions, and other resources, empowering both users and developers alike.`
